import * as React from "react";
import ManyCommoditiesFlowForm from "../../../components/Forms/MarketApartmentCommodities/FlowForm/FlowForm";

export default function ManyCommoditiesDefaultSettings() {
  return <ManyCommoditiesFlowForm />;
}
